import { Box, Skeleton, Tab } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CerebroBreadcrumb, CerebroPageContainer, CerebroSecondaryButton } from '../../../shared/components';
import { useAuth } from '../../../shared/context';
import { useDataRoomQuery, useDealQuery } from '../../../shared/hooks';
import { useDataRoomPartnerContactsQuery } from '../../../shared/hooks/Queries/useDataRoomPartnerContactsQuery';
import { DealPartnerContact, UnlockUser } from '../../../shared/models';
import { UnlockUserDialog } from '../UnlockUserDialog';
import { AddDataRoomPartnerContactForm } from './AddDataRoomPartnerContactForm';
import { DataRoomPartnerContactList } from './DataRoomParterContactList';
import { EditPartnerContactForm } from './EditPartnerContactForm';
import { SendAccountInfoForm } from './SendAccountInfoForm';

export const PartnerParticipants: React.FC = () => {
	const auth = useAuth();
	const { guid } = useParams();
	const dataRoomQuery = useDataRoomQuery(guid);

	const dealQuery = useDealQuery(dataRoomQuery.data?.dealGuid, {
		enabled: dataRoomQuery.isSuccess,
		retry: false,
	});

	const partnerContactsQuery = useDataRoomPartnerContactsQuery(guid);

	const [addContact, setAddContact] = React.useState<boolean>(false);
	const [removeAccess, setRemoveAccess] = React.useState<DealPartnerContact | null>(null);
	const [sendAccountInfo, setSendAccountInfo] = React.useState<DealPartnerContact | null>(null);
	const [unlockUser, setUnlockUser] = React.useState<UnlockUser | null>(null);
	

	const closeAndClearDialogs = () => {
		setAddContact(false);
		setRemoveAccess(null);
		setSendAccountInfo(null);
		setUnlockUser(null);
	};

	return (
		<CerebroPageContainer>
			<CerebroBreadcrumb>Participants &gt; Deal Partner Contacts</CerebroBreadcrumb>

			{(partnerContactsQuery.isLoading || dataRoomQuery.isLoading) && (
				<>
					<Skeleton height={200} />
					<Skeleton height={200} />
					<Skeleton height={200} />
				</>
			)}

			{partnerContactsQuery.isSuccess && dataRoomQuery.isSuccess && (
				<>
					<Box sx={{ marginBottom: 3 }}>
						<CerebroSecondaryButton sx={{ marginRight: 1 }} onClick={() => setAddContact(true)}>
							Add/Edit Access
						</CerebroSecondaryButton>
					</Box>
					<DataRoomPartnerContactList
						dataRoomGuid={guid}
						dataRoom={dataRoomQuery.data}
						contacts={partnerContactsQuery.data}
						currentUser={auth.currentUser}
						unlockUser={setUnlockUser}
						removeAccess={setRemoveAccess}
						sendAccountInfo={setSendAccountInfo}
					/>
				</>
			)}

			{dealQuery.isSuccess && (
				<AddDataRoomPartnerContactForm
					dataRoomGuid={guid}
					dealPartnerGuid={dealQuery.data.dealPartner?.guid}
					contacts={partnerContactsQuery.data}
					open={addContact}
					close={closeAndClearDialogs}
				></AddDataRoomPartnerContactForm>
			)}

			<EditPartnerContactForm
				dataRoomGuid={guid}
				contact={removeAccess}
				close={closeAndClearDialogs}
			></EditPartnerContactForm>

			<SendAccountInfoForm
				dataRoomGuid={guid}
				contact={sendAccountInfo}
				close={closeAndClearDialogs}
			></SendAccountInfoForm>

			<UnlockUserDialog
				dataRoomGuid={guid}
				user={unlockUser}
				close={closeAndClearDialogs}
			></UnlockUserDialog>


		</CerebroPageContainer>
	);
};
